import React from 'react';
import TimeAgo from 'timeago-react';
import { register } from 'timeago.js';
import language from 'timeago.js/lib/lang/pt_BR';
register('pt_BR', language);

const PostAuthor = ({ post }) => {
  return (
    <div className="author">
      <span>
        <img className="avatar" 
             alt={post.author.name}
             title={post.author.name}
             src={post.author.avatarUrl} />
      </span>
      <div className="info">
        <span className="name">{post.author.name}</span>
        <TimeAgo className="time" datetime={post.publishedAt} locale={'pt_BR'} />
      </div>
    </div>
  )
}

export default PostAuthor;